// src/components/ui/Spinner.tsx
import React from "react";
import stickWoman from "../../assets/spinner/loading-stwm.png";

const Spinner = () => {
  return (
    <div className="flex flex-col items-center justify-center space-y-2">
      <img
        src={stickWoman}
        alt="Loading woman with hair dryer"
        className="w-24 h-24 object-contain drop-shadow-xl"
      />
      <p className="text-[#d8a7a7] font-medium text-lg drop-shadow-xl">
        Loading<span className="after:content-[''] after:animate-loading-dots" />
      </p>
    </div>
  );
};

export default Spinner;
